export const deepEquals = (obj1, obj2) => {
  if (typeof obj1 === 'object' && typeof obj2 === 'object') {
    if (obj1 === null || obj2 === null) {
      return obj1 === obj2;
    }
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }
    return Object.keys(obj1).every(k => deepEquals(obj1[k], obj2[k]));
  }
  return obj1 === obj2;
};
export const findLast = (arr, predicate) => {
  let lastItem = undefined;
  arr.forEach(item => {
    if (predicate(item)) {
      lastItem = item;
    }
  });
  return lastItem;
};
export const intersection = (s1, s2) => {
  return new Set([...s1].filter(x => s2.has(x)));
};
export const difference = (s1, s2) => {
  return new Set([...s1].filter(x => !s2.has(x)));
};
export const prettyPrintJSON = jsonString => {
  try {
    return JSON.stringify(JSON.parse(jsonString), null, 2);
  } catch (e) {
    console.warn(e);
    return null;
  }
};
export const getNumberOfNewlinesInJson = jsonString => {
  return (jsonString.match(/\n/g) || []).length + 2;
};